import { theme } from 'src/styles/themes/default'

export const CloseCircle = ({ stroke = theme.primary.main, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity="0.1" cx="11" cy="11" r="11" fill={stroke} />
      <path
        d="M14.8801 7L7 14.8571"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7L14.8801 14.8571"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
